import { busSeatSelectionConstants } from './../constants/bus-seat-selection.constants'
import { isSameSeat, seatKeyOf } from './../helpers/seat-key.helper'

// Spec 055: a poltrona e comparada pela chave ANDAR + NUMERO. Comparar so pelo numero fazia a "01" do
// terreo e a "01" do superior se sobrescreverem no estado (selecionar uma marcava a outra).
const seatMatches = (seat, key) => isSameSeat(seat, key)

const initialState = {
	busSeatsGoing: [],
	poltronasIda: [],
	busSeatsReturn: [],
	poltronasVolta: [],
	totalSeatsGoing: 0,
	totalSeatsReturn: 0,
}

export default function busSeatSelectionReducer(state = initialState, action) {
	switch (action.type) {
		case busSeatSelectionConstants.SELECT_BUS_SEAT_GOING:
			let seatBusSelected = action.payload
			let newBusSeatsGoing = []

			let selectedKeyGoing = seatKeyOf(seatBusSelected)

			let updateBusSeatsGoing = state.busSeatsGoing.map((seat) => {
				if (seatMatches(seat, selectedKeyGoing)) {
					let updatedSeat = {
						...seat,
						...seatBusSelected,
						available: false,
					}

					if (!!seatBusSelected.conexao) {
						updatedSeat.dataViagem = seatBusSelected.conexao.departure
						updatedSeat.ordem = seatBusSelected.conexao.ordem
					}

					newBusSeatsGoing.push(updatedSeat)

					return updatedSeat
				}

				return seat
			})

			return {
				...state,
				busSeatsGoing: updateBusSeatsGoing,
				poltronasIda: [...state.poltronasIda, ...newBusSeatsGoing],
			}
		case busSeatSelectionConstants.DESELECT_BUS_SEAT_GOING:
			if (
				action.payload.conexao != null &&
				action.payload.conexao.ehConexaoIda
			) {
				var conexaoTrecho =
					action.payload.conexao.conexaoIda.trecho[
						action.payload.conexao.ordemViagemIda - 1
					]

				var deselectedKeyIda = action.payload.seatId || action.payload.busSeat

				var poltronaDeselecionada = state.poltronasIda.filter(
					(e) =>
						seatMatches(e, deselectedKeyIda) &&
						e.conexao == conexaoTrecho
				)

				var poltronasIdaFree = state.poltronasIda.filter(
					(e) => e !== poltronaDeselecionada[0]
				)

				var busSeatsGoing = state.busSeatsGoing.map((item) =>
					seatMatches(item, deselectedKeyIda)
						? ((item.available = true && item.conexao === conexaoTrecho),
						  delete item.transactionId,
						  delete item.bookingCode,
						  delete item.price,
						  delete item.withInsurance,
						  delete item.conexao,
						  delete item.ordem,
						  item)
						: item
				)

				return {
					...state,
					poltronasIda: poltronasIdaFree,
					busSeatsGoing: busSeatsGoing,
				}
			}

			let goingKey = action.payload.seatId || action.payload.busSeat

			let poltronasSelectedIda = state.poltronasIda.filter(
				(e) => !seatMatches(e, goingKey)
			)

			return {
				...state,
				poltronasIda: poltronasSelectedIda,
				busSeatsGoing: state.busSeatsGoing.map((item) =>
					seatMatches(item, goingKey)
						? ((item.available = true),
						  delete item.transactionId,
						  delete item.bookingCode,
						  delete item.price,
						  delete item.withInsurance,
						  item)
						: item
				),
			}

		case busSeatSelectionConstants.SELECT_BUS_SEAT_RETURN:
			let seatBusSelectedReturn = action.payload
			let newBusSeatsReturn = []

			let selectedKeyReturn = seatKeyOf(seatBusSelectedReturn)

			let updatedBusSeatsReturn = state.busSeatsReturn.map((seat) => {
				if (seatMatches(seat, selectedKeyReturn)) {
					let updatedSeat = {
						...seat,
						...seatBusSelectedReturn,
						available: false,
					}

					if (!!seatBusSelectedReturn.conexao) {
						updatedSeat.dataViagem =
							seatBusSelectedReturn.conexao.departure
						updatedSeat.ordem = seatBusSelectedReturn.conexao.ordem
					}

					newBusSeatsReturn.push(updatedSeat)

					return updatedSeat
				}

				return seat
			})

			return {
				...state,
				busSeatsReturn: updatedBusSeatsReturn,
				poltronasVolta: [...state.poltronasVolta, ...newBusSeatsReturn],
			}

		case busSeatSelectionConstants.DESELECT_BUS_SEAT_RETURN:
			const { conexao } = action.payload

			if (conexao && conexao.ehConexaoVolta) {
				var conexaoTrecho =
					action.payload.conexao.conexaoVolta.trecho[
						action.payload.conexao.ordemViagemVolta - 1
					]

				let deselectedKeyVolta = action.payload.seatId || action.payload.busSeat

				let poltronaDeselecionada = state.poltronasVolta.filter(
					(poltronaVolta) =>
						seatMatches(poltronaVolta, deselectedKeyVolta) &&
						poltronaVolta.conexao == conexaoTrecho
				)

				let poltronasVolta = state.poltronasVolta.filter(
					(e) => e !== poltronaDeselecionada[0]
				)

				let busSeatsReturn = state.busSeatsReturn.map((item) =>
					seatMatches(item, deselectedKeyVolta)
						? ((item.available = true),
						  delete item.transactionId,
						  delete item.bookingCode,
						  delete item.price,
						  delete item.withInsurance,
						  delete item.conexao,
						  delete item.ordem,
						  item)
						: item
				)

				return {
					...state,
					poltronasVolta: poltronasVolta,
					busSeatsReturn: busSeatsReturn,
				}
			}

			let returnKey = action.payload.seatId || action.payload.busSeat

			let poltronasSelectedVolta = state.poltronasVolta.filter(
				(e) => !seatMatches(e, returnKey)
			)

			return {
				...state,
				poltronasVolta: poltronasSelectedVolta,
				busSeatsReturn: state.busSeatsReturn.map((item) =>
					seatMatches(item, returnKey)
						? ((item.available = true),
						  delete item.transactionId,
						  delete item.bookingCode,
						  delete item.price,
						  delete item.withInsurance,
						  item)
						: item
				),
			}
		case busSeatSelectionConstants.LOAD_BUS_SEATS_GOING:
			return {
				...state,
				busSeatsGoing: action.payload,
			}
		case busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN:
			return {
				...state,
				busSeatsReturn: action.payload,
			}
		case busSeatSelectionConstants.SET_TOTAL_SEATS_GOING:
			return {
				...state,
				totalSeatsGoing: action.payload,
			}
		case busSeatSelectionConstants.SET_TOTAL_SEATS_RETURN:
			return {
				...state,
				totalSeatsReturn: action.payload,
			}
		case busSeatSelectionConstants.RESET:
			return initialState

		// Atualiza poltronas já reservadas, casadas pela reserva (transactionId) — ex.: o seguro
		// desligado/religado no passo de pagamento muda o flag e o preço da poltrona.
		case busSeatSelectionConstants.UPDATE_SELECTED_SEATS: {
			const updates = action.payload || {}
			const applyUpdate = (seat) =>
				seat.transactionId && updates[seat.transactionId]
					? { ...seat, ...updates[seat.transactionId] }
					: seat

			return {
				...state,
				poltronasIda: state.poltronasIda.map(applyUpdate),
				poltronasVolta: state.poltronasVolta.map(applyUpdate),
			}
		}

		case busSeatSelectionConstants.SET_ORDEM_VIAGEM_IDA:
			return {
				...state,
				ordemViagemIda: action.payload,
			}
		default:
			return state
	}
}
